import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { nextTick } from 'vue'
import { showToast } from 'vant';
import { useAuthStore } from '@/stores/auth'
declare module 'vue-router' {
  interface RouteMeta {
    miniTitle?: string // 小程序顶部导航栏标题（可选）
    navigationBarColor?: string // 小程序导航栏背景色（新增）
    keepAlive?: boolean // 页面缓存（你已经在用）
    title?: string // 网页标题（你在 else 分支用了）
  }
}
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/home',
      name: 'home-page',
      component: HomeView,
    },
    {
      path: '/user',
      name: 'userCenter',
      meta: { miniTitle: '大金服务' }, // 配置个人中心的小程序标题
      component: () => import('../views/UserView.vue'),
    },
    {
      path: '/page-login',
      name: 'loginView',
      meta: { miniTitle: '大金服务' }, // 配置个人中心的小程序标题
      component: () => import('../views/loginView.vue'),
    },
    {
      path: '/page-secuss',
      name: 'page-secuss',
      meta: { miniTitle: '提交成功' },
      component: () => import('../views/pagesView/subSecuss.vue'),
    },
    {
      path: '/page-h101',
      name: 'page-h101',
      meta: { miniTitle: '维修', keepAlive: true },
      component: () => import('../views/pagesView/H101.vue'),
    },
    {
      path: '/page-h102',
      name: 'page-h102',
      meta: { miniTitle: '移机', keepAlive: true },
      component: () => import('../views/pagesView/H102.vue'),
    },
    {
      path: '/page-h103',
      name: 'page-h103',
      meta: { miniTitle: '清洗保养', keepAlive: true },
      component: () => import('../views/pagesView/H103.vue'),
    },
    {
      path: '/page-h105',
      name: 'page-h105',
      meta: { miniTitle: '视频工程师', keepAlive: true },
      component: () => import('../views/pagesView/H105.vue'),
    },
    {
      path: '/page-h104',
      name: 'page-h104',
      meta: { miniTitle: '进度查询', keepAlive: true,  navigationBarColor: '#f9f9f9'},
      component: () => import('../views/pagesView/H104.vue'),
    },
    {
      path: '/page-h1042',
      name: 'page-h1042',
      meta: { miniTitle: '工单详情', keepAlive: true,  navigationBarColor: '#f9f9f9'},
      component: () => import('../views/pagesView/H104t.vue'),
    },
    {
      path: '/page-h107',
      name: 'page-h107',
      meta: { miniTitle: '收费标准', keepAlive: true, navigationBarColor: '#ecdcc3' },
      component: () => import('../views/pagesView/H107.vue'),
    },
    {
      path: '/page-h108',
      name: 'page-h108',
      meta: { miniTitle: '保修政策', navigationBarColor: '#ecdcc3' },
      component: () => import('../views/pagesView/H108.vue'),
    },
    {
      path: '/page-h109',
      name: 'page-h109',
      meta: { miniTitle: '服务标准', navigationBarColor: '#ecdcc3'},
      component: () => import('../views/pagesView/H109.vue'),
    },
    {
      path: '/page-h109-use',
      name: 'page-h109-use',
      meta: { miniTitle: '用户使用协议', navigationBarColor: '#ecdcc3'},
      component: () => import('../views/pagesView/H109-use.vue'),
    },
    {
      path: '/page-cancel-account',
      name: 'page-cancel-account',
      meta: { miniTitle: '账号注销', navigationBarColor: '#f9f9f9'},
      component: () => import('../views/pagesView/cancelAccount.vue'),
    },
    {
      path: '/page-cancel-account-verify',
      name: 'page-cancel-account-verify',
      meta: { miniTitle: '验证身份', navigationBarColor: '#f9f9f9'},
      component: () => import('../views/pagesView/cancelAccountVerify.vue'),
    },
    {
      path: '/page-about-daikin',
      name: 'page-about-daikin',
      meta: { miniTitle: '关于大金服务', navigationBarColor: '#f9f9f9'},
      component: () => import('../views/pagesView/aboutDaikin.vue'),
    },
    {
      path: '/page-cancel-account-failed',
      name: 'page-cancel-account-failed',
      meta: { miniTitle: '无法注销', navigationBarColor: '#f9f9f9'},
      component: () => import('../views/pagesView/cancelAccountFailed.vue'),
    },
    {
      path: '/page-h109-user',
      name: 'page-h109-user',
      meta: { miniTitle: '大金服务小程序个人信息保护政策', navigationBarColor: '#ecdcc3'},
      component: () => import('../views/pagesView/H109-user.vue'),
    },
    {
      path: '/page-h110',
      name: 'page-h110',
      meta: { miniTitle: '故障查询', navigationBarColor: '#ecdcc3'},
      component: () => import('../views/pagesView/H110.vue'),
    },
    {
      path: '/page-h111',
      name: 'page-h111',
      meta: { miniTitle: '遥控器说明', keepAlive: true, navigationBarColor: '#f9f9f9' },
      component: () => import('../views/pagesView/H111.vue'),
    },
    {
      path: '/page-h202',
      name: 'page-h202',
      meta: { miniTitle: '我的设备', navigationBarColor: '#f5f1f0'},
      component: () => import('../views/pagesView/H202.vue'),
    },
    {
      path: '/page-h203',
      name: 'page-h203',
      meta: { miniTitle: '发票管理', },
      component: () => import('../views/pagesView/H203.vue'),
    },
    {
      path: '/page-h204',
      name: 'page-h204',
      meta: { miniTitle: '发票填写', },
      component: () => import('../views/pagesView/H204.vue'),
    },
    {
      path: '/page-h205',
      name: 'page-h205',
      meta: { miniTitle: '地址管理', },
      component: () => import('../views/pagesView/H205.vue'),
    },
    {
      path: '/page-h206',
      name: 'page-h206',
      meta: { miniTitle: '地址填写', },
      component: () => import('../views/pagesView/H206.vue'),
    },
    {
      path: '/page-workreport',
      name: 'page-workreport',
      meta: { miniTitle: '我的报告书', },
      component: () => import('../views/pagesView/page-workreport.vue'),
    },
    {
      path: '/page-makevoice',
      name: 'page-makevoice',
      meta: { miniTitle: '申请开票', },
      component: () => import('../views/pagesView/page-makevoice.vue'),
    },
    {
      path: '/mini_app_repair',
      name: 'MiniJumpRepairIndex',
      component: () => import('../views/mini_jump_repair/Index.vue')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  }
})


router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  const storeUserInfo = authStore.getUserInfo();
  if (localStorage.getItem('userInfo') && !storeUserInfo) { // session 中有userInfo, 但是vuex中没有。则存储一下
    try {
      let sessionUserInfo = JSON.parse(localStorage.getItem('userInfo') as string)
      authStore.setUserInfo(sessionUserInfo)
    } catch (error) {
      console.error('解析 userInfo 失败:', error);
    }
  }
  if (to.name === 'page-h1042' && to.query.miniTitle) {
    // 创建新的 meta 对象，避免修改原始配置
    to.meta = {
      ...to.meta,
      miniTitle: to.query.miniTitle as string
    };
  }
  next()
})
router.afterEach(async (to) => {
  await nextTick()
})
export default router
